import { useEffect } from 'react';
import LoginCard from './LoginCard';
import { IMAGE_RUN } from '../../constants';
import PagePublic2Col from '../../components/Page/PagePublic2Col';
import { useTranslation } from '../../language';

export default function SignIn() {

  const { changeLanguage } = useTranslation();

  useEffect(() => { changeLanguage('de'); }, []);

return (

<PagePublic2Col

    leftsideimage={IMAGE_RUN}
    brandtext="Preventive Health Intelligence"
    headline=""
    formcomp={<LoginCard />}

  />

  )
}

